import Vue from 'vue';
import Router, { RouterOptions } from 'vue-router';

import { SessionStorage } from '@/enums/sessionStorage.enum';
import AppLayout from '@/AppLayout.vue';
import Home from '@/views/Home.vue';
import History from '@/views/History.vue';
import Benefits from '@/views/Benefits.vue';
import Login from '@/views/Login.vue';
import Register from '@/views/Register.vue';
import EditProfile from '@/views/EditProfile.vue';
import Consents from '@/views/Consents.vue';
import PageNotFound from '@/views/PageNotFound.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/logowanie',
      name: 'login',
      component: Login,
      meta: {
        title: 'Zaloguj się'
      }
    },
    {
      path: '/rejestracja',
      name: 'register',
      component: Register,
      meta: {
        title: 'Zarejestruj się'
      }
    },
    {
      path: '/',
      component: AppLayout,
      meta: {
        authorized: true,
        title: 'Twoja Karta'
      },
      children: [
        { path: '', component: Home, name: 'home' },
        { path: 'edycja', component: EditProfile, name: 'edit' },
        { path: 'zgody', component: Consents, name: 'consents' },
        {
          path: 'uslugi',

          component: Benefits,
          children: [
            {
              path: '',
              redirect: { name: 'benefits_all' }
            },
            {
              path: ':category(\\d+)',
              name: 'benefits_category',
              meta: {
                title: 'Usługi'
              }
            },
            {
              path: 'wydarzenia',
              name: 'benefits_events',
              meta: {
                title: 'Wydarzenia',
                events: true
              }
            },
            {
              path: 'wszystkie',
              name: 'benefits_all',
              meta: {
                title: 'Usługi'
              }
            }
          ]
        },

        {
          path: 'historia',
          component: History,
          name: 'history',
          meta: {
            title: 'Historia wykorzystania karty'
          }
        }
      ]
    },
    { path: '*', component: PageNotFound, meta: { authorized: true } }
  ]
} as RouterOptions);

router.beforeEach((to: any, from: any, next: any) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((record: any) => record.meta && record.meta.title);
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  if (to.matched.some((record: any) => record.meta.authorized)) {
    if (sessionStorage.getItem(SessionStorage.TOKEN) === null) {
      next({ name: 'login' });
    } else {
      // Sprawdzanie roli
      next();
    }
  } else {
    next();
  }
});

export default router;
